import React from 'react'

const MapPointerIcon = (props) => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20.001" viewBox="0 0 16 20.001"><path d="M8 20a57.861 57.861 0 0 1-4-4.5c-1.825-2.3-4-5.5-4-7.722a7.9 7.9 0 0 1 8-7.778 7.9 7.9 0 0 1 8 7.778c0 2.222-2.175 5.422-4 7.722a57.691 57.691 0 0 1-4 4.5zm0-19a6.913 6.913 0 0 0-7 6.806c0 1.921 1.889 4.712 3.474 6.715a50.14 50.14 0 0 0 3.526 3.979 50.088 50.088 0 0 0 3.608-4.081c2.219-2.819 3.392-5.109 3.392-6.613a6.913 6.913 0 0 0-7-6.806zm.222 8.445a2.222 2.222 0 1 1 2.222-2.222 2.225 2.225 0 0 1-2.222 2.222zm-.001-3.445a1.22 1.22 0 1 0 1.219 1.221 1.222 1.222 0 0 0-1.219-1.221z" fill={props.fill}/></svg>
	)
}

export default MapPointerIcon